import colors from './colors';

const darkTheme = {
  name: 'dark',
  colors: {
    // Text colors
    text: {
      primary: colors.neutral.white,
      secondary: colors.neutral.grey,
      disabled: colors.neutral.darkGrey,
      hint: colors.neutral.grey,
      link: colors.primary.light,
    },
    
    // Background colors
    background: {
      primary: 'rgba(0, 0, 0, 0.9)',
      secondary: 'rgba(0, 0, 0, 0.8)',
      tertiary: 'rgba(0, 0, 0, 0.7)',
      elevated: '#111111',
      paper: '#1A1A1A',
      input: 'rgba(0, 0, 0, 0.5)',
      hover: `rgba(${parseInt(colors.primary.main.slice(1, 3), 16)}, ${parseInt(colors.primary.main.slice(3, 5), 16)}, ${parseInt(colors.primary.main.slice(5, 7), 16)}, ${colors.alpha.light})`,
      active: `rgba(${parseInt(colors.primary.main.slice(1, 3), 16)}, ${parseInt(colors.primary.main.slice(3, 5), 16)}, ${parseInt(colors.primary.main.slice(5, 7), 16)}, ${colors.alpha.medium})`,
    },
    
    // Border colors
    border: {
      light: '#333333',
      main: '#444444',
      focus: colors.primary.main,
    },
    
    // Shadow colors
    shadow: {
      main: `rgba(${parseInt(colors.primary.main.slice(1, 3), 16)}, ${parseInt(colors.primary.main.slice(3, 5), 16)}, ${parseInt(colors.primary.main.slice(5, 7), 16)}, ${colors.alpha.medium})`,
      light: 'rgba(0, 0, 0, 0.2)',
    },
    
    // Button colors
    button: {
      primary: colors.primary.main,
      primaryHover: colors.primary.light,
      primaryActive: colors.primary.dark,
      secondary: 'transparent',
      secondaryHover: 'rgba(218, 0, 0, 0.1)',
      secondaryActive: 'rgba(218, 0, 0, 0.2)',
      disabled: colors.neutral.darkGrey,
    },
    
    // Accent colors (from the primary palette)
    accent: colors.primary.main,
    accentHover: colors.primary.light,
    accentActive: colors.primary.dark,
    
    // Gradient backgrounds
    gradient: {
      main: colors.gradients.darkRed,
      hover: colors.gradients.darkRedHover,
    },
  },
  
  // Typography settings
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: {
      xs: '0.75rem',    // 12px
      sm: '0.875rem',   // 14px
      md: '1rem',       // 16px
      lg: '1.125rem',   // 18px
      xl: '1.25rem',    // 20px
      xxl: '1.5rem',    // 24px
    },
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.5,
      relaxed: 1.75,
    },
  },
  
  // Spacing system
  spacing: {
    xs: '0.25rem',    // 4px
    sm: '0.5rem',     // 8px
    md: '1rem',       // 16px
    lg: '1.5rem',     // 24px
    xl: '2rem',       // 32px
    xxl: '3rem',      // 48px
  },
  
  // Border radius
  borderRadius: {
    sm: '0.25rem',    // 4px
    md: '0.5rem',     // 8px
    lg: '1rem',       // 16px
    full: '9999px',   // Circular
  },
  
  // Transitions
  transitions: {
    short: '0.15s ease',
    medium: '0.3s ease',
    long: '0.5s ease',
  },
  
  // Z-index levels
  zIndex: {
    base: 1,
    dropdown: 10,
    sticky: 100,
    modal: 1000,
    tooltip: 1500,
  },
};

export default darkTheme; 